/** zh-CN catalogue `state` (W3-09; English: src/state/state.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'state',
  locale: 'zh-CN',
  messages: {
    gestureActive: '请先完成或取消当前的拖动。',
    gestureEnded: '此拖动已经结束。',
    historyCleared: '已清除历史',
    historyDropped: '为了不超出内存限制，已移除最早的 {count, plural, other {# 个}}撤销步骤。“版本”中仍保留这些状态。',
    historyStale: '此处无法撤销：历史记录与项目不再一致。历史记录已清除；“版本”中仍保留更早的状态。',
    undoRefused: '撤销此步骤会破坏谱面。未做任何更改，历史记录已保留。',
    redoRefused: '重做此步骤会破坏谱面。未做任何更改，历史记录已保留。',
    txnRejected: '此更改会破坏谱面（{count, plural, other {# 个问题}}），因此未应用。',
  },
};

export default catalog;
